import { Injectable, OnDestroy, TemplateRef } from '@angular/core';
import { CmpsDialog, CmpsDialogRef } from '@cmps/ng-uikit';
import { tap } from 'rxjs/operators';

import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../../common/take-until-destroy.decorator';
import { BaseCallState } from '../../platform-call';
import { CallDialogComponent, CallDialogData } from '../call-dialog';
import { CallHudComponent } from '../call-hud/call-hud.component';

import { callHandleActive } from './function/call-handle-active.function';
import { CallHandle } from './model/call-handle.model';
import { CallState } from './model/call-state.model';
import { CallStatusNotification } from './model/call-status-notification.model';
import { HubMethods } from './model/hub-methods.model';
import { MeetingRequest } from './model/meeting-request.model';
import { SocketService } from './socket.service';

@Injectable({ providedIn: 'root' })
@TakeUntilDestroy()
export class CallStatusService implements OnDestroy {
    callHandle: CallHandle | null;

    /* TODO refactor */
    buttons: Array<TemplateRef<any>>;

    private _callDialogRef: CmpsDialogRef<CallDialogComponent, void>;
    private _callHudRef: CmpsDialogRef<CallHudComponent, void>;

    constructor(
        readonly socketService: SocketService,
        private readonly _dialog: CmpsDialog,
    ) {
        this._bind();
    }

    ngOnDestroy(): void {
        this.hideCallDialog();
        this.hideCallHud();
    }

    showCallDialog(opts: MeetingRequest): void {
        this._callDialogRef?.close();

        const data: CallDialogData = {
            meetingRequest: opts,
        };

        this._callDialogRef = this._dialog.open(CallDialogComponent, {
            movable: true,
            data,
        });
    }

    hideCallDialog(): void {
        this._callDialogRef?.close();
    }

    showCallHud(): void {
        if (this._callHudRef != null && !this._callHudRef.closed) {
            return;
        }

        this._callHudRef = this._dialog.open(CallHudComponent, {
            disableOverlayOverflowHidden: true,
            overlayClass: 'cmps-teamscall-call-hud--overlay-class',
            // portalClass: 'cmps-teamscall-call-hud--portal-class',
            portalWrapperClass: 'cmps-teamscall-call-hud--portal-wrapper-class',
            disableBackdrop: true,
            disableClose: true,
            // movable: true,
            placement: 'top-center',
        });
    }

    hideCallHud(): void {
        this._callHudRef?.close();
        this._callHudRef = null;
    }

    private _bind(): void {
        this.socketService.message
            .pipe(
                tap((msg) => {
                    switch (msg.hubMethod) {
                        case HubMethods.OnCurrentCall:
                            this._onCurrentCall(msg.payload);
                            break;
                        case HubMethods.OnCallStatus:
                            this._onCallStatus(msg.payload);
                            break;
                    }
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }

    private _onCurrentCall(payload: CallHandle | null): void {
        payload?.stateHistory?.forEach((e) => {
            e.timestamp = new Date(e.timestamp);
        });
        payload?.stateHistory?.sort((a, b) => +b.timestamp - +a.timestamp);
        this.callHandle = payload;

        if (callHandleActive(payload)) {
            this.showCallHud();
        } else {
            this.hideCallHud();
        }
    }

    private _onCallStatus(payload: CallStatusNotification | null): void {
        switch (payload?.status) {
            case CallState.MeetingStarted:
                this.showCallHud();
                break;
            case CallState.MeetingEnded:
            case BaseCallState.Ended:
                this.hideCallDialog();
                this.hideCallHud();
                break;
        }
    }
}
